import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tableAndBreadcrumContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    minWidth: '650px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    '@media (max-width: 900px)': {
      minWidth: '350px'
    }
  },
  breadcrumbHeader: {
    width: 'auto',
    height: '80px',
  },
  adminCardsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginLeft: 12,
  },
  adminBoxContainer: {
    '@media (max-height: 850px)': {
      maxHeight: 'calc(100% - 56px)',
      overflowY: 'auto'
    }
  },
  adminGridContainer: {
    '@media (max-height: 850px) and (max-width: 923px)': {
      maxHeight: 'calc(100% - 56px)',
      overflowY: 'auto'
    }
  }
}));
